function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "100%",
  height: "100%",
  fill: "#000"
}), /*#__PURE__*/React.createElement("rect", {
  width: "100%",
  height: "100%",
  fill: "url(#paint0_radial_463_12470)",
  fillOpacity: ".6"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_463_12470",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(521.35151 1301.06082 -1922.89443 770.5281 419 523.5)"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: ".49",
  stopColor: "#412515"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".953"
})))));